import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

interface Endpoints {
  cursos: string;
  instrutores: string;
  salas: string;
  inscricoesTotais: string;
  cursoSimulacao: string;
  turmaEfetiva: string;
}

@Injectable({
  providedIn: 'root',
})
export class BaseService {
  private _endpoints: Readonly<Endpoints>;
  constructor() {
    this._endpoints = this.criaEndpoints(environment.serverUrl);
  }

  get endpoints(): Readonly<Endpoints> {
    return this._endpoints;
  }

  private criaEndpoints(apiUrl: string) {
    return {
      cursos: `${apiUrl}/cursos`,
      instrutores: `${apiUrl}/instrutores`,
      salas: `${apiUrl}/salas`,
      inscricoesTotais: `${apiUrl}/inscricoes/{idCurso}/totais`,
      cursoSimulacao: `${apiUrl}/cursos/{idCurso}/monta-turmas`,
      turmaEfetiva: `${apiUrl}/turmas/efetiva`,
    };
  }
}
